import { Component } from 'react';
import { intersection } from 'ramda';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { TABS } from '../constants';
import s from './PoiSheet.module.scss';

export default class PoiTabBar extends Component {
    static propTypes = {
        changedFields: PropTypes.arrayOf(PropTypes.string),
        onSelectTab: PropTypes.func,
        selectedTabId: PropTypes.string,
    };

    static defaultProps = {
        changedFields: [],
        onSelectTab: () => {},
        selectedTabId: 'info',
    };

    renderTabItem = tabItem => {
        const { changedFields, selectedTabId, onSelectTab } = this.props;
        const hasChanges = intersection(changedFields, tabItem.fields).length > 0;
        const classes = classNames(s.tabItem, { [s.selected]: tabItem.id === selectedTabId, [s.dirty]: hasChanges });

        return (
            <div className={classes} key={tabItem.id} onClick={() => onSelectTab(tabItem.id)} data-testid={`${tabItem.id}-tab`}>
                {tabItem.label}
            </div>
        );
    };

    render = () => {
        return <div className={s.tabBar}>{TABS.map(this.renderTabItem)}</div>;
    };
}
